<small class="key">{{ key }}:</small>
<small class="value" [class.tooltip-set]="tooltip" [ttTooltip]="tooltip">{{ value }}</small>
